import { BaseInteractionManager } from '@nab/nab-x-sdk-core';

/**
 * [[include:packages/consumer/sdk-browser/src/DataSecurityMgr/InteractionManager/README.md]]
 */
class InteractionMgr extends BaseInteractionManager {}

export { InteractionMgr };
